import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: ${calculateResponsiveSize(14)};
    color: #000000;
    line-height: 1.25;
    background: #ffffff;
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* scrollbar-color: #F2EEE8 #DDD2C4;
    &::-webkit-scrollbar-track {
      background: #DDD2C4;
    }
    &::-webkit-scrollbar-thumb {
      background: #F2EEE8;
    } */
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(14)};
    }
  }
  body{
    overflow-y: scroll;
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Instrument Sans', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: #000000;
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  svg path, svg circle, svg line{ transition: all 0.25s ease 0s; }
  button { font-weight: 400; }
  .home-content {
    will-change: transform; 
  }
  /* ----- react-select ----- */
  @keyframes selectSlideInOut {
    0% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* ----- For br ----- */
  .for-mobile {
    display: none;
  }
  ${mediaMax('mobile')} {
    .for-desktop {
      display: none;
    }
    .for-mobile {
      display: inline;
    }
  }

  /* ----- Animations ----- */
  .fadeIn {
    transform: translateY(85%);
    transition: transform 1s;
    &.visible {
      transform: translateY(0);
    }
  }
`

export default GlobalStyle
